import { action } from 'mobx'
import { recommendPriceTableData, priceDetailDrawerState } from './stores'

export const setRecommendPriceTableData = action(
  (data) => {
    recommendPriceTableData.data = data
  }
);
export const setPriceDetailDrawerVisible = action(
  (visible, priceData, rank) => {
    priceDetailDrawerState.visible = visible
    priceDetailDrawerState.priceData = priceData
    priceDetailDrawerState.rank = rank
  }
);